<script>
    import { location } from "svelte-spa-router";

    import { v4 } from "uuid";
    import {
        createSidebarTooltip,
        removeSidebarTooltip,
    } from "./helper/sidebarHelper.svelte";

    export let sidebarExpanded;
    export let isShow = true;
    export let title;
    export let iFont = "";
    export let routesArr = [];

    let isCollapsed = true;

    let uuid;

    $: mainRoute = $location.toString().split("/")[1];

    $: isFocused = isCollapsed && routesArr.includes(mainRoute);

    const handleMouseEnter = (e) => {
        if (sidebarExpanded) return;

        const { target } = e;

        if (!target) return;

        const targetRect = target.getBoundingClientRect();

        uuid = v4();

        const position = {
            top: targetRect.top,
            right: targetRect.right,
            bottom: targetRect.bottom,
        };

        createSidebarTooltip(position, uuid, `${title} Tab`);
    };

    const handleMouseLeave = () => removeSidebarTooltip(uuid);
</script>

{#if isShow}
    <!-- svelte-ignore a11y-mouse-events-have-key-events -->
    <div
        class={`tabContainer w-full pr-4 pl-2 py-[10px] cursor-pointer ${
            isFocused ? "isFocused" : ""
        }`}
        on:click|preventDefault={() => (isCollapsed = !isCollapsed)}
        on:mouseenter={handleMouseEnter}
        on:mouseleave={handleMouseLeave}
    >
        <div
            class="urlContainer text-primary flex justify-between"
            {...$$restProps}
        >
            <div class="flex items-center w-full">
                <div class="flex items-center gap-x-2 w-full">
                    <div class="w-[25px]">
                        <i
                            class={`${iFont} text-[#6f726C] font-bold`}
                            style={`font-size:${
                                sidebarExpanded ? "18px" : "15px"
                            }`}
                        />
                    </div>

                    {#if sidebarExpanded}
                        <div class="flex w-full items-center">
                            <p class={`text-[#6f726C] font-bold`}>
                                {title}
                            </p>
                        </div>

                        <i
                            style="font-size: 15px"
                            class={`fa text-[#6F726C] rounded-lg ${
                                isCollapsed ? "rotate-back" : "rotate-180"
                            }`}
                        >
                            &#xf107;
                        </i>
                    {:else}
                        <div class="flex items-center">
                            <i
                                style="font-size: 8px"
                                class={`fa text-[#6F726C] rounded-lg ${
                                    isCollapsed ? "rotate-back" : "rotate-180"
                                }`}
                            >
                                &#xf107;
                            </i>
                        </div>
                    {/if}
                </div>
            </div>
        </div>
    </div>
{:else}
    <div class="hidden" />
{/if}

<div
    class={`flex flex-col w-full ${
        isCollapsed ? "isCollapsed" : "isExpanded mb-3"
    } ${sidebarExpanded ? "pl-[25px]" : "pl-[10px]"}`}
>
    <div class={`w-full ${isCollapsed ? "hidden" : ""}`}>
        <slot />
    </div>
</div>

<style>
    .tabContainer:hover,
    .isFocused {
        border: 0 solid rgba(0, 0, 0, 0.02);
        border-radius: 0px 50px 50px 0px;
        background: linear-gradient(
            270deg,
            rgba(39, 0, 83, 0.2397) 16.85%,
            rgba(39, 0, 83, 0.0893) 71.98%
        );
    }

    .urlContainer {
        font-size: 16px;
        line-height: 24px;
    }

    .rotate-back {
        transform: rotate(0deg);
        transition: 0.3s linear;
    }

    .rotate-180 {
        transform: rotate(180deg);
        transition: 0.3s linear;
    }

    .isCollapsed {
        max-height: 0;
        opacity: 0;
        transition: all 0.3s ease;
    }

    .isExpanded {
        max-height: 500px;
        opacity: 1;
        transition: all 0.3s ease;
    }

    p {
        font-size: 15px;
        line-height: 18px;
    }
</style>
